export const { VITE_BASE_URL } = import.meta.env;
export const { VITE_API_URL } = import.meta.env;
export const { VITE_SENTRY_DSN } = import.meta.env;
export const { VITE_ASSETS_API_URL } = import.meta.env;